import { z } from 'zod';
import * as directoryScheme from './directoryScheme';

export const shipNameHelper =
  'Ship name is required. It must have at least 2 characters, max 300 characters, no special characters allowed';
export const shipNameSchema = directoryScheme.createNameSchema({
  name: 'Ship Name',
  minLength: 2,
  maxLength: 300,
  allowSpecialChars: false,
  allowNumbers: true,
  required: true,
});

export const shipSchema = z.object({
  id: directoryScheme.idSchema,
  name: shipNameSchema,
});

export const shipPartialSchema = shipSchema.partial({
  id: true,
});
